import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import {Calendar} from "primereact/calendar";
import {InputText} from "primereact/inputtext";
import { loadAllCalendarLocales } from "./CalendarTranslate";

const dateFormatMappings = {
    en: "mm/dd/yy",
    de: "dd.mm.yy",
    fr: "dd/mm/yy",
    it: "dd/mm/yy",
    // Additional language mappings here
};

// Definición de un componente funcional
const FormFilterDropdown = ({ newDateValues, newReferenceName  }) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const [ date, setDate] = useState(null);
    const [ reference, setReference] = useState([]);
    const [isValidDate, setIsValidDate] = useState(false);
    const [localesReady, setLocalesReady] = useState(false);

    const setRangeDate = (value) => {

        if (value) {
            setDate(value)
            newDateValues(value)
        }
        else {
            newDateValues([])
            setDate(null)
            setIsValidDate(true);
        }
    }

    const setRefenceValue = (value) => {
        setReference(value)
        newReferenceName(value)
    }

    useEffect(() => {
        loadAllCalendarLocales(t);
        setLocalesReady(true);

    }, [t]);

    if (!localesReady) return null; // Espera a registrar los locales

    const dateFormat = dateFormatMappings[currentLanguage] || "dd/mm/yy"; // Default to some format if undefined for a language

    return (
        <div className="filter-container flex flex-wrap text-white">
            <InputText
                value={reference}
                onChange={(e) => setRefenceValue(e.target.value)}
                placeholder={t('search')}
                className="w-full md:w-14rem mr-4 input-mimetika text-xs p-2 my-1 sm:my-0 lg:my-2 "
            />
            <Calendar
                value={date}
                onChange={(e) => setRangeDate(e.value)}
                selectionMode="range"
                placeholder={t('Filter by date')}
                showIcon
                icon="pi pi-calendar text-sm"
                dateFormat={dateFormat}
                locale={currentLanguage}
                hideOnDateTimeSelect={true}
                showButtonBar
                className="calendar-mimetika mr-4 my-1 sm:my-0 lg:my-2 w-56"
            />
        </div>
    );
}

export default FormFilterDropdown;
